export interface SecurityHeatState {
  heat: number;
  tier: number;
  label: "Green" | "Yellow" | "Orange" | "Red" | "Blackout";
  scoreScale: number;
  xpScale: number;
  rareChanceBonus: number;
  reason: string;
}

export interface SecurityHeatInput {
  elapsed: number;
  collected: number;
  bestCombo: number;
  bonusTimeEarned: number;
}

export const securityHeatFor = (input: SecurityHeatInput): SecurityHeatState => {
  const performance = input.collected * 1.8 + input.bestCombo * 0.65;
  const persistence = input.elapsed * 0.28 + input.bonusTimeEarned * 0.2;
  const heat = Math.min(100, Math.max(0, performance + persistence));
  const tier = Math.min(4, Math.floor(heat / 20));
  const labels: SecurityHeatState["label"][] = ["Green", "Yellow", "Orange", "Red", "Blackout"];
  const reasons = [
    "Security monitoring",
    "Fast collection detected",
    "Predictive security online",
    "Adaptive security online",
    "Maximum reward lockdown",
  ];
  return {
    heat,
    tier,
    label: labels[tier],
    scoreScale: 1 + tier * 0.05,
    xpScale: 1 + tier * 0.06,
    rareChanceBonus: tier * 0.015,
    reason: reasons[tier],
  };
};
